import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import BusinessSection from '../components/BusinessSection';
import StrengthSection from '../components/StrengthSection';
import NumbersSection from '../components/NumbersSection';
import ProductsSection from '../components/ProductsSection';
import TrustSection from '../components/TrustSection';
import CompanyPreview from '../components/CompanyPreview';
import ContactCTA from '../components/ContactCTA';

const HomePage = () => (
  <>
    <Helmet>
      <title>RYU株式会社｜酒類の可能性を、広げる。</title>
      <meta
        name="description"
        content="RYU株式会社は、酒類卸売・EC・流通を一体で展開し、幅広い商品力と供給力で全国のビジネスを支える酒類流通企業です。"
      />
      <meta
        name="keywords"
        content="RYU株式会社, 酒類卸売, 酒類流通, 法人向け酒類, 業務用配送, 物流, ウイスキー仕入れ, 日本酒, EC, 楽天, Amazon"
      />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="RYU株式会社｜酒類の可能性を、広げる。" />
      <meta
        property="og:description"
        content="商品力と供給力を一つの流れへ。酒類卸売・EC・物流を動かす流通企業です。"
      />
      <meta property="og:url" content="https://www.ryukk.jp/" />
      <meta property="og:image" content="https://www.ryukk.jp/ogp.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="RYU株式会社｜酒類の可能性を、広げる。" />
      <meta
        name="twitter:description"
        content="商品力と供給力を一つの流れへ。酒類卸売・EC・物流を動かす流通企業です。"
      />
      <meta name="twitter:image" content="https://www.ryukk.jp/ogp.jpg" />
      <link rel="canonical" href="https://www.ryukk.jp/" />
    </Helmet>
    <Hero />
    <AboutSection />
    <BusinessSection />
    <StrengthSection />
    <ProductsSection />
    <NumbersSection />
    <CompanyPreview />
    <TrustSection />
    <ContactCTA />
  </>
);

export default HomePage;
